import { Theme, Screens } from 'patient-api-lib'
import { IntegrationType, WidgetMode } from '../models/enums'

/* Handlers for window access iframe/embedded */
export interface TDLSettings {
  mode?: WidgetMode | null
  apiToken: string | null
  clinicIds?: string[] | null
  iframeHeight?: number | string | null
  treatmentIds?: string[] | null
  enableScrolling?: boolean
  integrationType?: IntegrationType | null
  initialScreen?: Screens | null
  theme?: Theme | null
}

export const getWindow = () => {
  try {
    if (window.location !== window.parent?.location) {
      return window.parent
    } else {
      return window
    }
  } catch (error) {
    return window
  }
}

export const getWindowDocument = () => {
  try {
    return getWindow()?.document
  } catch (error) {
    return window.document
  }
}

export const checkIsIframe = () => {
  const hostWindow = getWindow()
  return window.location !== hostWindow?.location
}

export const getSettingsFromWindow = () => {
  const hostWindow = getWindow()

  const settings: TDLSettings = {
    mode: null,
    apiToken: null,
    clinicIds: null,
    iframeHeight: null,
    treatmentIds: null,
    enableScrolling: true,
    integrationType: null,
    theme: null,
    initialScreen: null,
  }

  try {
    if (hostWindow.tdlWidgetConfig?.mode === WidgetMode.Embedded) {
      Object.assign(settings, hostWindow.tdlWidgetConfig)
    }
  } catch (error) {
    return settings
  }

  return settings
}

export const getLocationSearch = () => {
  try {
    return getWindow()?.location?.search
  } catch (error) {
    return window.location.search
  }
}
